import React, { useState, useRef } from 'react';
import styles from './Home.module.css';
import emailjs from '@emailjs/browser';

export default function ConsultaPersonalizada() {
  const formRef = useRef(null);
  const [paso, setPaso] = useState(1);
  const [pagoRealizado, setPagoRealizado] = useState(false);
  const [nombre, setNombre] = useState('');

  const enviarDatos = e => {
    e.preventDefault();
    const form = formRef.current;

    emailjs.sendForm(
      'service_xep7hpt',         // ✅ Tu Service ID
      'template_55f84de',       // ✅ Tu Template ID
      form,
      'u8LhoIe5CwjHOxOkG'       // ✅ Tu Public Key
    )
    .then(() => {
      const formData = new FormData(form);
      const nombreUsuario = formData.get('nombre');
      const emailUsuario = formData.get('email');
      setNombre(nombreUsuario);
      localStorage.setItem('emailUsuario', emailUsuario);
      setPaso(2);
    })
    .catch(error => {
      console.error('❌ Error al enviar email:', error);
      alert('Hubo un problema al enviar tus datos. Intenta nuevamente.');
    });
  };

  const realizarPago = () => {
    setPagoRealizado(true);
    window.location.href = 'https://pay.hotmart.com/L101272134U';
  };

  return (
    <div className={styles.container} style={{ backgroundColor: '#121212', fontSize: '1.15rem', padding: '4rem 1rem' }}>
      <div className={styles.hero}>
        <h1 className={styles.title} style={{ fontSize: '2.5rem' }}>Consulta personalizada</h1>
        <h2 className={styles.subtitle} style={{ fontSize: '1.75rem' }}>Entrenamiento exclusivo según tus metas</h2>
        <p className={styles.description} style={{ fontSize: '1.2rem' }}>
          Completa tus datos y accedé a una rutina diseñada específicamente para usted.
          Comunicación directa con el entrenador + seguimiento individual una vez al mes.
        </p>
      </div>

      <div className={styles.section} style={{ maxWidth: '850px', margin: '0 auto' }}>
        {paso === 1 && (
          <form ref={formRef} onSubmit={enviarDatos} style={{ backgroundColor: '#1f1f1f', padding: '3rem', borderRadius: '10px' }}>
            <h2 style={{ color: '#2f6fa2', marginBottom: '2rem', fontSize: '1.5rem' }}>Paso 1 — Datos personales</h2>

            {[
              ['Nombre', 'nombre'],
              ['Apellido', 'apellido'],
              ['Email', 'email'],
              ['Celular', 'celular'],
              ['Ubicación', 'ubicacion'],
              ['Peso (kg)', 'peso'],
              ['Altura (cm)', 'altura']
            ].map(([label, name], idx) => (
              <div key={idx} style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '.75rem', color: '#aaa', fontSize: '1.1rem' }}>{label}</label>
                <input
                  type={name === 'email' ? 'email' : 'text'}
                  name={name}
                  required
                  style={{
                    width: '100%',
                    padding: '1rem',
                    fontSize: '1.1rem',
                    backgroundColor: '#121212',
                    color: '#fff',
                    border: '1px solid #333',
                    borderRadius: '6px'
                  }}
                />
              </div>
            ))}

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '.75rem', color: '#aaa', fontSize: '1.1rem' }}>Objetivo físico</label>
              <textarea
                name="objetivo"
                rows="4"
                required
                style={{
                  width: '100%',
                  padding: '1rem',
                  fontSize: '1.1rem',
                  backgroundColor: '#121212',
                  color: '#fff',
                  border: '1px solid #333',
                  borderRadius: '6px'
                }}
              />
            </div>

            <button type="submit" className={styles.primaryBtn} style={{ fontSize: '1.2rem', padding: '1rem 2rem' }}>
              Continuar al pago
            </button>
          </form>
        )}

        {paso === 2 && !pagoRealizado && (
          <div style={{ backgroundColor: '#1f1f1f', padding: '3rem', borderRadius: '10px', marginTop: '3rem' }}>
            <h2 style={{ color: '#2f6fa2', fontSize: '1.5rem' }}>💳 Paso 2 — Realizar pago</h2>
            <p style={{ color: '#ccc', marginBottom: '1rem', fontSize: '1.15rem' }}>
              Consulta personalizada: <strong>$30</strong>
            </p>
            <button onClick={realizarPago} className={styles.primaryBtn} style={{ fontSize: '1.2rem', padding: '1rem 2rem' }}>
              Pagar ahora
            </button>
          </div>
        )}

        {paso === 2 && pagoRealizado && (
          <div style={{ backgroundColor: '#1f1f1f', padding: '3rem', borderRadius: '10px', marginTop: '3rem' }}>
            <h2 style={{ color: '#2f6fa2', fontSize: '1.5rem' }}>✅ Confirmación</h2>
            <p style={{ color: '#ccc', fontSize: '1.2rem' }}>
              Gracias {nombre}. En breve te contactaremos por WhatsApp para coordinar tu rutina personalizada.
            </p>
          </div>
        )}
      </div>

      <footer className={styles.footer} style={{ fontSize: '1rem', marginTop: '2rem' }}>
        CalisXcore © {new Date().getFullYear()} — Evolución con método
      </footer>
    </div>
  );
}
